import { downloadBlobAsFile } from '@diana/core';

export const exportData = (
  data: Record<string, any>[],
  fileName: string,
  dataKey: string = 'data',
): void => {
  if (data.length > 0) {
    // Extract the first item's data to get headers
    const firstItem = data[0][dataKey];
    const headers = Object.keys(firstItem);

    const escapeCSV = (value: string) => {
      if (value.includes('"')) {
        value = value.replace(/"/g, '""');
      }
      if (value.includes(',') || value.includes('"') || value.includes('\n') || value.includes('\r')) {
        return `"${value}"`;
      }
      return value;
    };

    // Create CSV rows
    const rows = data.map((item) => {
      const rowData = item[dataKey];
      return headers
        .map((header) => {
          const value = rowData[header];
          // Handle different value types
          if (typeof value === 'boolean') return value ? 'true' : 'false';
          if (value === null || value === undefined) return '';
          if (typeof value === 'object') return escapeCSV(JSON.stringify(value));
          return escapeCSV(value.toString());
        })
        .join(',');
    });

    // Add headers as first row
    rows.unshift(headers.map(escapeCSV).join(','));

    // Convert string to Blob
    const csvContent = rows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create and download the file
    downloadBlobAsFile(blob, `${fileName}.csv`, true);
  }
};
